var map = {
	"./personality-relax-beijing.jpeg": "0d7e",
	"./personality-relax-bingdao.jpeg": "0606",
	"./personality-relax-riben.jpeg": "1f09",
	"./personality-relax-shenzhen.jpeg": "b3ac",
	"./personality-relax-taiguo.jpeg": "3969"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1114";